import { Flex } from 'antd';
import classNames from 'classnames';
import React from 'react';

import { Status, Typography } from '@/shared/ui';

import { getTimeFromISOString } from '@/helpers/dates';

import { NotificationType, StatusDecorator } from '@/api/types';

import './NotificationsStyles.scss';

interface Props {
  type: NotificationType;
  title: string;
  message: string;
  date: string;
  status_decorator?: Nullable<StatusDecorator>;
  onNotificationClick: () => void;
}

export const Notification = React.memo<Props>(
  ({ type, title, message, date, status_decorator, onNotificationClick }) => {
    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
      <div className={classNames('notifications__item', `notifications__item--${type}`)} onClick={onNotificationClick}>
        <Flex justify="space-between" align="start" gap={8}>
          <div className="item__content-container">
            {status_decorator ? <Status status={status_decorator} classname="item__status" /> : null}
            {title ? (
              <Typography variant="TEXT16" color={type === 'warn' ? 'red' : 'black'} className="notifications__title">
                {title}
              </Typography>
            ) : null}
            <Typography>{message}</Typography>
          </div>
          <Typography variant="TEXT14">{getTimeFromISOString(date)}</Typography>
        </Flex>
      </div>
    );
  },
);
